var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("pancho-willies-food-item", {
    attrs: {
      item: _vm.item,
      "pricing-types": _vm.pricingTypes,
      "price-layout": "price-below",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }